export enum ActivityType {
  SEARCH = "SEARCH",
  VIEW_PRODUCT = "VIEW_PRODUCT",
  VIEW_CATEGORY = "VIEW_CATEGORY",
  ADD_TO_CART = "ADD_TO_CART",
  PURCHASE = "PURCHASE",
  ADD_TO_WISHLIST = "ADD_TO_WISHLIST",
}

export interface ActivityDetail {
  eventType: ActivityType;
  productId?: string;
  ssin?: string;
  productVariantId?: string;
  categoryName?: string;
  searchQuery?: string;
}

export interface CreateActivityPayload {
  activities: ActivityDetail;
  userId?: string;
  sessionId?: string;
}

export interface KeepShoppingBrand {
  _id?: string;
  name?: string;
}

export interface KeepShoppingReviews {
  averageRating: number;
  totalReviews: number;
}

export interface KeepShoppingItem {
  _id: string;
  name: string;
  mainImage: string;
  ssin?: string;
  brand?: KeepShoppingBrand;
  categoryHierarchy?: Record<string, any>;
  reviews?: KeepShoppingReviews;
  eventType?: ActivityType;
  interactedAt?: string | Date;
}

// ==========================================
// Customer Wishlist Types
// ==========================================

export enum WishlistSortBy {
  NEWEST = "newest",
  OLDEST = "oldest",
  NAME = "name",
}

export interface AddToWishlistPayload {
  productId: string;
  productVariantId?: string;
  note?: string;
}

export interface UpdateWishlistItemPayload {
  productId: string;
  productVariantId?: string;
  note?: string;
}

export interface WishlistQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: WishlistSortBy;
}

export interface WishlistItem {
  _id: string;
  wishlistItemId: string;
  name: string;
  mainImage: string;
  ssin?: string;
  brand?: KeepShoppingBrand;
  categoryHierarchy?: Record<string, any>;
  reviews?: KeepShoppingReviews;
  productVariantId?: string;
  note?: string;
  addedAt: string;
}

export interface WishlistPagination {
  page: number;
  limit: number;
  totalPages: number;
}

export interface WishlistResponse {
  items: WishlistItem[];
  total: number;
  pagination: WishlistPagination;
}

export interface WishlistCheckResponse {
  isWishlisted: boolean;
  wishlistItemId?: string;
}

export interface ActivityState {
  // Activity state
  keepShopping: KeepShoppingItem[];
  recentSearches: string[];
  recentCategories: string[];
  keepShoppingLoaded: boolean;
  recentSearchesLoaded: boolean;
  recentCategoriesLoaded: boolean;

  // Wishlist state
  wishlist: WishlistItem[];
  wishlistTotal: number;
  wishlistPagination: WishlistPagination | null;
  wishlistCheckMap: Record<string, boolean>;
  wishlistLoading: boolean;
  wishlistError: string | null;

  // Common status
  loading: boolean;
  error: string | null;
  success: boolean;
}

export interface BaseResponse<T> {
  success: boolean;
  message: string;
  data: T;
}
